import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { DossierService } from '../../services/dossier.service';
import moment from 'moment';
import { showToast } from '../../utils/misc/toast-utils';
let filterInitialized = false;
export const loading = writable(false);
export const filter = writable({ criteria: {}, params: null, sorting: "" });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export async function initList() {
    if (filterInitialized === false) {
        let now = moment().startOf("day").local().toDate();
        let year = now.getFullYear();
        let criteria = { query: '', year: year };
        filter.set({ criteria: criteria, params: null, sorting: "" });
        filterInitialized = true;
    }
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    if (oid == 0) {
        let now = moment().startOf("day").local().toDate();
        // let year = now.getFullYear();
        //console.log("new portal user: ");
        record.set({ oid: 0, startYear: 0, endYear: 0, startDate: now, effectDate: now, deadlineDate: now, endDate: null });
    }
    else {
        let _resp = await DossierService.fetchDossier(oid);
        //console.log("fetched portal user: ", _resp);
        record.set(_resp.payload);
        await loadStats(_resp.payload.oid);
    }
}
async function loadStats(dossierOid) {
    let _resp = await DossierService.fetchDossierStats(dossierOid);
    stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await DossierService.getDossiers(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/dossier/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/dossier/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await DossierService.saveDossier(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await DossierService.deleteDossier(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function bulkChangeInvoicingStatus(invoiced) {
    let _record = get(record);
    if (_record == null)
        return;
    let status = invoiced ? 1 : 0;
    let _resp = await DossierService.bulkChangeDossierInvoiceStatus(_record.oid, status);
    showToast("Stato di fatturazione modificato", 'is-success');
    return _resp;
}
